import {DateType, EnumType, JacksonType, JsonIdentityInfo} from "@sonner/jackson-service-v2";
import {SonnerBaseEntity} from "../modules/core/classes/sonner.base.entity";
import {EscritPapel} from "./escrit.papel";
import {EscrituracaoObraUnica} from "./escrituracao.obra.unica";
import {Municipio} from "./municipio";
import {NotaFiscal} from "./nota.fiscal";
import {Pessoa} from "./pessoa";
import {TipoAbatimentoObra} from "./tipo.abatimento.obra";
import {SituacaoObraUnicaEnum} from "../enums/situacao.obra.unica.enum";
import {ValueDisplayable} from "../modules/ui/interface/value.displayable";
import {Estado} from "./estado";
import {RelacaoObraNotaEscrit} from "./relacao.obra.nota.escrit";
import { Pais } from './pais';

@JacksonType("ObraUnica")
@JsonIdentityInfo()
export class ObraUnica extends SonnerBaseEntity implements ValueDisplayable {

  id: number;

  alvara: string;

  bairro: string;

  cep: string;

  complemento: string;

  @DateType()
  dataInicio: Date;

  descricao: string;

  documentoProprietario: string;

  @DateType()
  emissao: Date;

  @JacksonType("EscritPapel")
  escritPapel: EscritPapel;

  @JacksonType("Estado")
  estado: Estado;

  @JacksonType("Pessoa")
  fiscal: Pessoa;

  logradouro: string;

  @JacksonType("Municipio")
  municipio: Municipio;

  nomeProprietario: string;

  @JacksonType("NotaFiscal")
  nota: NotaFiscal;

  numero: string;

  @JacksonType("Pessoa")
  pessoa: Pessoa;

  @EnumType(SituacaoObraUnicaEnum)
  situacao: SituacaoObraUnicaEnum = SituacaoObraUnicaEnum.SemAnalise;

  @DateType()
  ultimaAlteracao: Date;

  @JacksonType("TipoAbatimentoObra")
  tipoAbatimentoObra: TipoAbatimentoObra;

  @JacksonType("EscrituracaoObraUnica")
  escrituracoes: EscrituracaoObraUnica[];


  @JacksonType("RelacaoObraNotaEscrit")
  notasEscrits: RelacaoObraNotaEscrit[];

  saldo: number;

  codigo: string;

  inscricaoImobiliaria: string;

  @JacksonType("Pais")
  pais: Pais;

  cidadeExterior: string;

  estadoExterior: string;
  // aux

  totalParaAbatimento: number;

  getDisplayValue(): string {
    let enderecoObra: string = "";
    if(this.logradouro){
      enderecoObra = this.logradouro;
    }

    if(this.numero){
      enderecoObra += ", " + this.numero;
    }

    if(this.complemento){
      enderecoObra += ", " + this.complemento;
    }

    if(this.bairro){
      enderecoObra += ", " + this.bairro;
    }

    if(this.municipio!=null){
      enderecoObra += ", " + this.municipio.nome;
    }else if(this.cidadeExterior){
      enderecoObra += ", " + this.cidadeExterior;
    }

    if(this.estado!=null){
      enderecoObra += " - " + this.estado.codigo;
    }else if(this.estadoExterior){
      enderecoObra += " - " + this.estadoExterior;
    }

    if(this.cep){
      enderecoObra += ", " + this.cep;
    }

    if(this.pais!=null){
      enderecoObra += " - " + this.pais.nome;
    }

    let dadosFmt: string = "";

    if(this.id!=null){
      dadosFmt = this.id.toString();
    }

    if(this.descricao){
      dadosFmt += " - " + this.descricao;
    }

    if(this.codigo){
      dadosFmt += " - Código Obra: " + this.codigo;
    }

    if(this.inscricaoImobiliaria){
      dadosFmt += " - Insc Imob.: " + this.inscricaoImobiliaria;
    }

    if(enderecoObra || "BRASIL" === enderecoObra.toUpperCase()){
      return dadosFmt;
    }

    return dadosFmt + " - Endereço da obra: " + enderecoObra ;
  }

}
